const hi = {
  common: {
    nav: { services: "सेवाएँ", about: "हमारे बारे में", guides: "गाइड", contact: "संपर्क" },
    cta: "प्रोजेक्ट शुरू करें",
    language: "भाषा",
    themeToLight: "लाइट मोड पर जाएँ",
    themeToDark: "डार्क मोड पर जाएँ",
    menuOpen: "मेनू खोलें",
    menuClose: "मेनू बंद करें",
    optional: "वैकल्पिक",
    reply: "हम 7 घंटे के भीतर जवाब देते हैं।",
    scroll: "स्क्रॉल करें",
  },
  footer: {
    tagline: "AI ऑटोमेशन, वेबसाइट और ऐप — उन टीमों के लिए जो दोहराए जाने वाले काम सिस्टम को सौंपना चाहती हैं।",
    company: "कंपनी",
    policies: "नीतियाँ",
    elsewhere: "सोशल",
    location: "बीकानेर, राजस्थान, भारत · दुनिया भर में सेवा",
    legal: {
      terms: "नियम और शर्तें",
      privacy: "गोपनीयता नीति",
      refund: "रिफंड नीति",
      return: "रिटर्न नीति",
      cancellation: "रद्दीकरण नीति",
      shipping: "शिपिंग नीति",
    },
  },
  cookie: {
    title: "कुकीज़, आपकी अनुमति से",
    body: "साइट चलाने के लिए हम ज़रूरी कुकीज़ का उपयोग करते हैं। आपकी सहमति से हम साइट को बेहतर बनाने के लिए एनालिटिक्स कुकीज़ भी उपयोग करते हैं।",
    accept: "सभी स्वीकार करें",
    reject: "केवल ज़रूरी",
    policy: "गोपनीयता नीति",
  },
  cta: {
    title: "कोई ऐसा काम जो अपने-आप चलना चाहिए?",
    body: "हमें बताइए आपको क्या चाहिए। हम 7 घंटे के भीतर जवाब देते हैं।",
    primary: "बातचीत शुरू करें",
    secondary: "सेवाएँ देखें",
  },
  home: {
    hero: {
      eyebrow: "AI ऑटोमेशन और सॉफ़्टवेयर स्टूडियो",
      titleA: "हम ऐसे सिस्टम बनाते हैं",
      titleB: "जो आपके लिए काम करें।",
      lede: "AI एजेंट, ऑटोमेशन, वेबसाइट और ऐप — डिज़ाइन से लॉन्च तक, पूरी ज़िम्मेदारी के साथ।",
      primary: "प्रोजेक्ट शुरू करें",
      secondary: "हमारा काम देखें",
      tags: ["AI एजेंट", "ऑटोमेशन", "वेब ऐप", "मोबाइल ऐप", "डेटा पाइपलाइन", "AI वीडियो"],
    },
    marquee: ["AI एजेंट", "RAG सिस्टम", "वर्कफ़्लो ऑटोमेशन", "वेबसाइट", "वेब ऐप", "मोबाइल ऐप", "वेब स्क्रैपिंग", "AI वीडियो", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "साल AI सिस्टम बनाते हुए" },
      { value: 100, suffix: "+", label: "ऑटोमेट किए गए वर्कफ़्लो" },
      { value: 7, suffix: " घं.", label: "अधिकतम जवाब का समय" },
    ],
    services: { label: "हम क्या करते हैं", title: "चार तरीके जिनसे हम मदद करते हैं।", more: "सभी सेवाएँ" },
    work: {
      label: "चुनिंदा काम",
      title: "लाइव प्रोजेक्ट जो हमने बनाए हैं।",
      intro: "असली साइट देखने के लिए कोई भी कार्ड खोलें।",
      nextLabel: "आपका प्रोजेक्ट",
      nextTitle: "अगला आपका हो सकता है।",
      nextBody: "वेबसाइट, ऐप और ऑटोमेशन — शुरू से अंत तक।",
      nextCta: "हमें बताइए",
      visit: "साइट नए टैब में खोलें",
    },
    process: {
      label: "हम कैसे काम करते हैं",
      title: "आइडिया से लॉन्च तक, चार कदम।",
      steps: [
        { title: "समझना", desc: "आपके लक्ष्य को समझने के लिए मुफ़्त कॉल।" },
        { title: "योजना", desc: "साफ़ लिखित योजना और समय-सीमा।" },
        { title: "निर्माण", desc: "हर पड़ाव पर काम करता डेमो।" },
        { title: "लॉन्च", desc: "लाइव होना, उसके बाद सपोर्ट।" },
      ],
    },
    testimonials: { label: "क्लाइंट की राय", title: "हमारे क्लाइंट क्या कहते हैं।" },
  },
  services: {
    eyebrow: "सेवाएँ",
    title: "आपके लक्ष्य पर केंद्रित सेवाएँ।",
    lede: "हर प्रोजेक्ट एक मुफ़्त डिस्कवरी कॉल से शुरू होता है।",
    timeline: "सामान्य समय",
    included: "क्या शामिल है",
    tools: "हमारे टूल",
    showTools: "टूल देखें",
    hideTools: "टूल छिपाएँ",
    options: "शुरुआत के विकल्प",
    choose: "चुनें",
    discuss: "अपने प्रोजेक्ट पर बात करें",
    extrasTitle: "ये भी उपलब्ध",
    extras: ["AI कंसल्टिंग", "आर्किटेक्चर डिज़ाइन", "API इंटीग्रेशन", "क्लाउड और DevOps", "मेंटेनेंस और सपोर्ट", "समर्पित इंजीनियर"],
    items: {
      "ai-automation": {
        title: "AI ऑटोमेशन",
        tagline: "एजेंट और असिस्टेंट जो आपकी टीम का दोहराव वाला काम संभालें।",
        timeline: "2–12 सप्ताह",
        includes: ["प्रोसेस मैपिंग", "AI चैटबॉट और एजेंट", "नॉलेज असिस्टेंट (RAG)", "CRM और टूल इंटीग्रेशन", "30 दिन सपोर्ट"],
        plans: [
          { name: "स्टार्टर ऑटोमेशन", note: "एक वर्कफ़्लो · 2–3 सप्ताह" },
          { name: "बिज़नेस ऑटोमेशन सुइट", note: "कई वर्कफ़्लो · 4–6 सप्ताह" },
          { name: "एंटरप्राइज़ AI सिस्टम", note: "पूरा इंटीग्रेशन · 8–12 सप्ताह" },
        ],
      },
      "web-development": {
        title: "वेबसाइट और वेब ऐप",
        tagline: "तेज़, आधुनिक साइट और ऐप जिन्हें चलाना आसान हो।",
        timeline: "1–10 सप्ताह",
        includes: ["UI/UX डिज़ाइन", "रिस्पॉन्सिव डेवलपमेंट", "एडमिन पैनल", "SEO और परफ़ॉर्मेंस", "60 दिन सपोर्ट"],
        plans: [
          { name: "स्टैटिक बिज़नेस वेबसाइट", note: "5–7 पेज · 1–2 सप्ताह" },
          { name: "एडमिन के साथ डायनेमिक वेबसाइट", note: "एडमिन पैनल · 3–4 सप्ताह" },
          { name: "पूरी तरह कस्टम वेब ऐप", note: "कस्टम फ़ीचर · 6–10 सप्ताह" },
        ],
      },
      "python-automation": {
        title: "Python और डेटा",
        tagline: "स्क्रिप्ट, स्क्रैपर और पाइपलाइन जो अपने-आप चलें।",
        timeline: "3 दिन–4 सप्ताह",
        includes: ["कस्टम स्क्रिप्ट", "वेब स्क्रैपिंग", "डेटा प्रोसेसिंग", "शेड्यूल्ड जॉब", "लॉगिंग और डॉक्यूमेंटेशन"],
        plans: [
          { name: "सरल ऑटोमेशन स्क्रिप्ट", note: "एक काम · 3–5 दिन" },
          { name: "वेब स्क्रैपिंग समाधान", note: "कई पेज · 1–2 सप्ताह" },
          { name: "जटिल डेटा पाइपलाइन", note: "कई स्रोत · 2–4 सप्ताह" },
        ],
      },
      "ai-video": {
        title: "AI वीडियो और अवतार",
        tagline: "बड़ी मात्रा में वीडियो कंटेंट, बिना एडिटर के।",
        timeline: "2–10 सप्ताह",
        includes: ["कस्टम अवतार", "वॉइस सिंथेसिस", "स्क्रिप्ट से वीडियो", "ब्रांड स्टाइलिंग", "टीम ट्रेनिंग"],
        plans: [
          { name: "बेसिक AI वीडियो सेटअप", note: "एक अवतार · 2–3 सप्ताह" },
          { name: "प्रोफ़ेशनल अवतार सिस्टम", note: "वॉइस क्लोनिंग · 4–5 सप्ताह" },
          { name: "एंटरप्राइज़ वीडियो प्लेटफ़ॉर्म", note: "API और व्हाइट-लेबल · 6–10 सप्ताह" },
        ],
      },
    },
  },
  about: {
    eyebrow: "हमारे बारे में",
    title: "व्यावहारिक AI बनाने वाली एक छोटी टीम।",
    lede: "हम दोहराव वाले काम को भरोसेमंद सिस्टम से बदलते हैं — एक स्क्रिप्ट से पूरे प्लेटफ़ॉर्म तक।",
    storyLabel: "हमारी कहानी",
    story: "हमने Optivra Tech इसलिए शुरू किया ताकि आधुनिक AI रोज़मर्रा के कारोबार तक पहुँचे। पहले हम समझते हैं कि आप कैसे काम करते हैं, फिर वही बनाते हैं जो सही बैठे।",
    valuesLabel: "हमारे मूल्य",
    values: [
      { title: "मिशन", desc: "व्यावहारिक AI और ऑटोमेशन से मापने योग्य विकास।" },
      { title: "विज़न", desc: "बढ़ते कारोबारों का भरोसेमंद टेक्नोलॉजी पार्टनर।" },
      { title: "प्रतिबद्धता", desc: "अच्छा काम, साफ़ बातचीत, असली नतीजे।" },
    ],
    skillsLabel: "विशेषज्ञता",
    skillsTitle: "हम किसमें माहिर हैं।",
    skillsHint: "टूल देखने के लिए कार्ड पर कर्सर ले जाएँ या टैप करें।",
    skills: [
      { title: "AI और ML", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "बैकएंड", tools: "Python · FastAPI · Node.js · Django" },
      { title: "फ़्रंटएंड", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "डेटा", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "क्लाउड", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "ऑटोमेशन", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "टीम",
    team: ["AI और ऑटोमेशन इंजीनियर", "फ़ुल-स्टैक डेवलपर", "सॉल्यूशन आर्किटेक्ट", "DevOps इंजीनियर"],
    whyLabel: "हम क्यों",
    why: [
      { title: "तेज़", desc: "छोटे चक्र, काम करते डेमो।" },
      { title: "आधुनिक", desc: "परखे हुए, नए टूल।" },
      { title: "साफ़", desc: "डॉक्यूमेंटेड, आसानी से संभलने वाला कोड।" },
    ],
  },
  contact: {
    eyebrow: "संपर्क",
    title: "आइए बात करें।",
    lede: "अपने प्रोजेक्ट के बारे में बताइए। हम 7 घंटे के भीतर जवाब देते हैं।",
    name: "पूरा नाम",
    email: "ईमेल",
    phone: "फ़ोन",
    subject: "विषय",
    subjectPh: "जैसे: इनवॉइस प्रोसेसिंग ऑटोमेट करना",
    message: "संदेश",
    messagePh: "आपको क्या चाहिए और कौन-से टूल इस्तेमाल होते हैं?",
    send: "संदेश भेजें",
    sending: "भेजा जा रहा है…",
    privacy: "हम आपकी जानकारी कभी साझा नहीं करते।",
    okTitle: "संदेश भेज दिया गया",
    okBody: "धन्यवाद! हम 7 घंटे के भीतर जवाब देंगे।",
    errTitle: "कुछ गड़बड़ हो गई",
    errBody: "संदेश नहीं भेजा जा सका। कृपया दोबारा कोशिश करें।",
    emailLabel: "ईमेल",
    phoneLabel: "फ़ोन",
    hoursLabel: "समय",
    hours: "सोम–शनि, सुबह 9 से शाम 7 बजे (IST)",
  },
  checkout: {
    eyebrow: "प्रोजेक्ट शुरू करें",
    title: "बताइए आपको क्या चाहिए।",
    lede: "सबसे नज़दीकी विकल्प चुनें। दायरा हम आपके साथ तय करेंगे।",
    details: "आपकी जानकारी",
    project: "प्रोजेक्ट",
    name: "पूरा नाम",
    company: "कंपनी",
    email: "ईमेल",
    phone: "फ़ोन",
    service: "सेवा",
    selectService: "सेवा चुनें",
    option: "विकल्प",
    selectOption: "विकल्प चुनें",
    notes: "प्रोजेक्ट नोट्स",
    notesPh: "इसे क्या करना चाहिए? किन टूल से जुड़ना है?",
    agree: "मैं सहमत हूँ —",
    and: "और",
    submit: "प्रोजेक्ट अनुरोध भेजें",
    submitting: "भेजा जा रहा है…",
    summary: "सारांश",
    summaryService: "सेवा",
    summaryOption: "विकल्प",
    next: "दायरा और अगले कदम तय करने के लिए हम 7 घंटे के भीतर जवाब देते हैं।",
    empty: "कोई सेवा और विकल्प चुनें।",
    perks: ["सुरक्षित प्रक्रिया", "7 दिन में रिफंड विंडो", "7 घंटे में जवाब"],
    refundLink: "रिफंड नीति",
    termsTitle: "शर्तें स्वीकार करना ज़रूरी है",
    termsBody: "आगे बढ़ने के लिए कृपया शर्तें स्वीकार करें।",
    okTitle: "अनुरोध मिल गया",
    okBody: "धन्यवाद! हम 7 घंटे के भीतर संपर्क करेंगे।",
    errTitle: "कुछ गड़बड़ हो गई",
    errBody: "अनुरोध नहीं भेजा जा सका। कृपया दोबारा कोशिश करें।",
  },
  guide: {
    eyebrow: "गाइड",
    title: "असली क्लाइंट प्रोजेक्ट से बनी व्यावहारिक गाइड।",
    lede: "AI, ऑटोमेशन और करियर पर स्टेप-बाय-स्टेप प्लेबुक।",
    badges: ["तुरंत PDF डाउनलोड", "ईमेल पर कॉपी", "PhonePe से सुरक्षित भुगतान"],
    listLabel: "उपलब्ध गाइड",
    listTitle: "एक गाइड चुनें।",
    mins: "मिनट",
    levels: { "All Levels": "सभी स्तर", Beginner: "शुरुआती", Intermediate: "मध्यम", Advanced: "एडवांस" },
    choose: "चुनें",
    selected: "चुना गया",
    items: {
      g0: "मनचाही नौकरी पाने का 30–45 दिन का प्लान: रिज़्यूमे, इंटरव्यू और आउटरीच।",
      g1: "ComfyUI में डिफ़्यूज़न मॉडल, कस्टम नोड और तेज़ प्रोटोटाइपिंग।",
      g2: "ऐसे ऑटोनॉमस सिस्टम बनाएँ जो मैन्युअल काम की जगह लें।",
      g3: "वेक्टर डेटाबेस, चंकिंग और नॉलेज एजेंट डिप्लॉय करना।",
      g4: "n8n होस्ट करें और वेबहुक से कई ऐप वाले फ़्लो बनाएँ।",
    },
    buyLabel: "चेकआउट",
    buyTitle: "अपनी कॉपी पाएँ।",
    buySub: "आपके इनवॉइस और डाउनलोड लिंक ईमेल करने के लिए।",
    name: "पूरा नाम",
    phone: "फ़ोन",
    email: "ईमेल",
    country: "देश",
    countries: { India: "भारत", "United States": "संयुक्त राज्य अमेरिका", "United Kingdom": "यूनाइटेड किंगडम", Canada: "कनाडा", Australia: "ऑस्ट्रेलिया", Germany: "जर्मनी", Other: "अन्य" },
    gst: "GST नंबर",
    company: "कंपनी का नाम",
    agree: "मैं सहमत हूँ —",
    and: "और",
    terms: "नियम और शर्तें",
    refund: "रिफंड नीति",
    pay: "{amount} सुरक्षित रूप से चुकाएँ",
    redirecting: "भुगतान पेज पर ले जाया जा रहा है…",
    buying: "आप खरीद रहे हैं",
    format: "PDF गाइड · डिजिटल डाउनलोड",
    price: "कीमत",
    gstLine: "GST ({percent}%)",
    total: "कुल",
    loadingPrice: "कीमत लोड हो रही है…",
    methods: "UPI, कार्ड, नेट बैंकिंग या वॉलेट से भुगतान करें।",
    secure: "भुगतान PhonePe द्वारा सुरक्षित रूप से प्रोसेस किए जाते हैं।",
    faqLabel: "सवाल-जवाब",
    faqTitle: "आम सवाल।",
    faqs: [
      { q: "गाइड किस फ़ॉर्मेट में मिलती हैं?", a: "डायग्राम, कोड और स्टेप-बाय-स्टेप निर्देशों वाली PDF।" },
      { q: "यह कितनी जल्दी मिलेगी?", a: "तुरंत। आप डाउनलोड पेज पर पहुँचेंगे और ईमेल पर भी कॉपी मिलेगी।" },
      { q: "क्या रिफंड मिल सकता है?", a: "गाइड तुरंत डाउनलोड होने वाली डिजिटल चीज़ है, इसलिए रिफंड सीमित हैं। रिफंड नीति देखें।" },
      { q: "गाइड कौन लिखता है?", a: "हमारे इंजीनियर, क्लाइंट के लिए बनाए सिस्टम के अनुभव से।" },
    ],
    errors: {
      "Full name is required": "पूरा नाम ज़रूरी है",
      "Email is required": "ईमेल ज़रूरी है",
      "Please enter a valid email": "कृपया सही ईमेल डालें",
      "Phone number is required": "फ़ोन नंबर ज़रूरी है",
      "Please enter a valid phone number": "कृपया सही फ़ोन नंबर डालें",
      "You must accept the terms": "आपको शर्तें स्वीकार करनी होंगी",
      "Something went wrong. Please try again.": "कुछ गड़बड़ हो गई। कृपया दोबारा कोशिश करें।",
    },
  },
  success: {
    verifying: "आपके भुगतान की पुष्टि हो रही है…",
    pending: "भुगतान अभी प्रोसेस हो रहा है",
    checking: "अपने-आप दोबारा जाँच हो रही है ({n}/10)",
    checkAgain: "फिर से जाँचें",
    paid: "भुगतान मिल गया। धन्यवाद!",
    downloads: "आपके डाउनलोड",
    dlGuide: "गाइड डाउनलोड करें (PDF)",
    dlInvoice: "इनवॉइस डाउनलोड करें (PDF)",
    linksNote: "लिंक 24 घंटे तक मान्य हैं। एक कॉपी आपके ईमेल पर भी भेजी गई है।",
    expired: "यह डाउनलोड लिंक समाप्त हो चुका है",
    failed: "यह पूरा नहीं हो सका",
    support: "सपोर्ट से संपर्क करें",
    home: "होम पर वापस जाएँ",
    errors: {
      "No order ID found. Please check your payment email for order details.": "ऑर्डर नहीं मिला। विवरण के लिए भुगतान वाला ईमेल देखें।",
      "Payment failed. Please try again.": "भुगतान विफल रहा। कृपया दोबारा कोशिश करें।",
      "Unable to verify payment status.": "भुगतान की स्थिति की पुष्टि नहीं हो सकी।",
      "Download links have expired after 24 hours.": "24 घंटे बाद डाउनलोड लिंक समाप्त हो गए हैं।",
      "Unable to fetch download links.": "डाउनलोड लिंक नहीं मिल सके।",
      "Download failed. Please try again or contact support.": "डाउनलोड विफल रहा। दोबारा कोशिश करें या सपोर्ट से संपर्क करें।",
      "Something went wrong.": "कुछ गड़बड़ हो गई।",
    },
  },
  legal: { notice: "यह नीति अंग्रेज़ी में प्रकाशित है, और अंग्रेज़ी संस्करण ही कानूनी रूप से मान्य है।" },
  work: {
    kke: { kind: "क्लाइंट वेबसाइट", summary: "दुनिया भर में निर्यात करने वाले इंडस्ट्रियल सप्लायर के लिए बहुभाषी कैटलॉग साइट।", highlights: ["अंग्रेज़ी, फ़्रेंच और अरबी", "12 प्रोडक्ट लाइन", "कोटेशन और WhatsApp"] },
    pokemac: { kind: "हमारा प्रोडक्ट · macOS ऐप", summary: "एक मज़ेदार मेन्यू-बार ऐप जो थपकी, ढक्कन और USB पर प्रतिक्रिया देता है।", highlights: ["नेटिव macOS", "डिवाइस पर ही चलता है"] },
    drillbuddy: { kind: "हमारा प्रोडक्ट · Android ऐप", summary: "कुश्ती, MMA और बैडमिंटन के लिए ऑडियो-आधारित रिएक्शन ड्रिल।", highlights: ["Google Play", "एडजस्टेबल इंटेंसिटी"] },
    prayer: { kind: "हमारा प्रोडक्ट · Android ऐप", summary: "थीम और रोज़ की प्रगति वाला एक शांत प्रार्थना काउंटर।", highlights: ["8 भाषाएँ", "Google Play"] },
  },
};

export default hi;
